import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpRequest, HttpParams } from '@angular/common/http';
import { tap, map } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { ServerTypes } from 'src/app/models/servers';

export interface DataListItems {
  url: string;
  items: any[];
  totalCount?: number;
}

const totalCountHeader = 'X-Total-Count'.toLowerCase();

@Injectable({ providedIn: 'root' })
export class DynamicDataListService {
  // todo this service could be refactored into reusable cached data
  private dataListItemsCache: DataListItems[] = [];

  constructor(private apiService: ApiService, private httpClient: HttpClient) { }

  getItems(
    url: string,
    serverType: string,
    page?: number,
    perPage?: number,
    useCache: boolean = true
  ): Observable<{
    items: any[];
    totalCount: number;
  }> {
    const serverTypeValue = ServerTypes[serverType] ?? ServerTypes.boapi;

    let params = new HttpParams();
    if (page) params = params.append('page', page.toString());
    if (perPage) params = params.append('perpage', perPage.toString());

    const httpRequest = new HttpRequest('GET', this.apiService.joinUrl(serverTypeValue, url), {
      params,
    });

    if (useCache) {
      let cachedItems = this.dataListItemsCache.find(
        (dataListItem) => dataListItem.url === httpRequest.urlWithParams
      );
      if (cachedItems) {
        return of({
          items: cachedItems.items,
          totalCount: cachedItems.totalCount,
        });
      }
    }

    return this.httpClient
      .get<any[]>(httpRequest.urlWithParams, { observe: 'response' })
      .pipe(
        tap((response) => {
          this.dataListItemsCache.push({
            url: httpRequest.urlWithParams,
            items: response.body,
            totalCount: Number(
              response.headers.get(totalCountHeader)
                ? response.headers.get(totalCountHeader)
                : response.body.length
            ),
          });
        }),
        map((response) => {
          return {
            items: response.body,
            totalCount: Number(
              response.headers.get(totalCountHeader)
                ? response.headers.get(totalCountHeader)
                : response.body.length
            ),
          };
        })
      );
  }
}
